import arrayIndexOfEl from './arrayIndexOfEl';
import arrayInsertByIndex from './arrayInsertByIndex';

export function arrayInsert<T>(arr: T[], newItem: T): T[] {
  return [...arr, newItem];
}

export default arrayInsert;
